import React from 'react';
import { List, SearchInput, DateInput, ReferenceInput, AutocompleteInput } from 'react-admin';

import StatusInput from './inputs/StatusInput';
import InvoiceTypeInput from './inputs/InvoiceTypeInput';

import InvoiceRow from './InvoiceRow';

const optionText = choice => choice.name ? choice.name : '';

const invoiceFilters = [
	<SearchInput source="q" alwaysOn />,
	<ReferenceInput source="customer_id" reference="customers" sort={{ field: 'name', order: 'ASC' }} alwaysOn>
		<AutocompleteInput optionText={optionText} label="Customer" />
	</ReferenceInput>,
	<DateInput source="start_date" alwaysOn />,
	<DateInput source="end_date" alwaysOn />,
	<StatusInput source="status" alwaysOn />,
	<InvoiceTypeInput source="invoice_type" alwaysOn />
];

const InvoiceList = props => (
	<List {...props} filters={invoiceFilters} sort={{ field: 'id', order: 'DESC' }} exporter={false}>
		<InvoiceRow />
	</List>
);

export default InvoiceList;